import PropTypes from 'prop-types'

import { useLanguageContext } from '../../../context'
import { useChartData } from '../../../hooks/use-chart-data'
import RadarChart from '../../react-chart/radar-chart'
import { sortRadarChartData } from './sortRadarChartData'

const RadarChartComplete = ({
  spaces,
  career,
  footer,
  emptyState,
  minDimensions = 1
}) => {
  const { language } = useLanguageContext()

  const { extractChartData, options } = useChartData({
    spaces,
    careers: career ? [career] : undefined
  })

  const chartData = sortRadarChartData(extractChartData())

  // useChartData schneidet die Dimensionen aller Spaces. Bleibt zu wenig
  // uebrig, hat das Diagramm keine Achsen oder es entartet zu einer Linie.
  // Dann gehoert an diese Stelle eine Erklaerung, kein leerer Chart.
  if (chartData.dimensions.length < minDimensions) return emptyState || null

  return (
    <>
      <div className='relative h-auto w-full'>
        <RadarChart
          data={{
            labels: chartData.dimensions.map(
              ({ property }) => property[language]
            ),
            datasets: [
              ...chartData.spaces.map((space) => ({
                ...space,
                data: space.data.map(({ result }) => result)
              })),
              ...chartData.careers.map((item) => ({
                ...item,
                data: item.data.map(({ optimal }) => optimal)
              }))
            ]
          }}
          options={options}
        />
      </div>
      {footer}
    </>
  )
}

RadarChartComplete.propTypes = {
  spaces: PropTypes.array.isRequired,
  career: PropTypes.object,
  footer: PropTypes.node,
  emptyState: PropTypes.node,
  minDimensions: PropTypes.number
}

export default RadarChartComplete
